/**
 * Loading skeleton for menu page
 * Matches the actual menu layout: horizontal cards with image on right
 */
import { Skeleton } from '@/components/ui'

export function MenuLoadingSkeleton() {
  return (
    <div className="space-y-8 animate-fade-in">
      {/* Featured Carousel Skeleton */}
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <div className="space-y-2">
            <Skeleton className="h-7 w-40" />
            <Skeleton className="h-4 w-56" />
          </div>
          <div className="flex gap-2">
            <Skeleton className="h-8 w-8 rounded-full" />
            <Skeleton className="h-8 w-8 rounded-full" />
          </div>
        </div>
        <div className="flex gap-3 overflow-hidden">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="shrink-0 w-48 sm:w-52">
              <Skeleton className="w-full h-40 rounded-xl mb-3" />
              <Skeleton className="h-4 w-3/4 mb-1" />
              <Skeleton className="h-4 w-16" />
            </div>
          ))}
        </div>
      </div>

      {/* Category Pills Skeleton */}
      <div className="flex gap-2 overflow-hidden py-3">
        {[1, 2, 3, 4, 5].map((i) => (
          <Skeleton key={i} className="h-10 w-24 rounded-full shrink-0" />
        ))}
      </div>

      {/* Section + Cards Skeleton */}
      {[1, 2].map((section) => (
        <div key={section} className="space-y-4">
          <div className="space-y-2">
            <Skeleton className="h-7 w-44" />
            <Skeleton className="h-4 w-64" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="flex items-start gap-4 p-3 sm:p-4 rounded-2xl bg-card shadow-card">
                <div className="flex-1 space-y-2 py-0.5">
                  <Skeleton className="h-5 w-3/4" />
                  <Skeleton className="h-4 w-full" />
                  <Skeleton className="h-4 w-1/2" />
                  <Skeleton className="h-5 w-20 mt-1" />
                </div>
                <Skeleton className="w-[108px] h-[108px] sm:w-[128px] sm:h-[128px] rounded-2xl shrink-0" />
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}
